import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { TopicDetails } from 'lcc-state/interfaces';
import { TableBodyRow } from './table-body-row';
import { ColSpecMap } from './table';

export interface TableBodyProperties {
	tbody: TopicDetails;
	widths: ColSpecMap;
}

const factory = create({ theme }).properties<TableBodyProperties>();

export const TableBody = factory(({ properties }) => {
	const { tbody, widths } = properties();
	const { children = [] } = tbody;
	let firstchild = true;

	const allrows = children.map((rowitem) => {
		const entries = rowitem.row.children as { [key: string]: TopicDetails }[];
		const tr = w(TableBodyRow, { entries, rowAttrs: rowitem.row.attributes, firstchild, widths });
		firstchild = false;
		return tr;
	});

	return v('tbody', {}, allrows);
});
